module.exports = __webpack_public_path__ + "img/adalliance_logo_row.cd0b0075.svg";